import { actions } from '@ignitesales/neuro-application';
import classnames from 'classnames';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';

const { startGuide } = actions.navigation;

const LandingPage = ({className, startGuideClicked, processingNavigation}) => {
  const cssBEM = 'landingPage';
  const classes = classnames(cssBEM, className);

  const onStartGuideClick = () => {
    startGuideClicked('checking');
  };

  return (
    <div className={classes}>
      <div className="container">
        <div className={`${cssBEM}__center`}>
          <FormattedMessage id="landing.title" tagName="h2" />
          <FormattedMessage id="landing.message" tagName="span" />
          <button onClick={onStartGuideClick} disabled={processingNavigation} className="btn btn-primary dialogue-background-primary">
            <FormattedMessage id="landing.readyToStart" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default connect(
  ({ processingNavigation = false }) => {
    return {
      processingNavigation,
    };
  },
  (dispatch) => {
    return {
      startGuideClicked: (selectedPath) => dispatch(startGuide(selectedPath)),
    };
  }
)(LandingPage);
